import { motion } from "motion/react";
import { Network, Users, Radio, MapPinned, TrendingUp, FileCheck2, MessageCircle, ArrowUpRight } from "lucide-react";

const SERVICIOS = [
  {
    icon: Network,
    title: "Estrategia y estructura organizacional",
    text: "Diseñamos arquitecturas que alinean visión, procesos y personas para crecer sin perder el rumbo.",
  },
  {
    icon: Users,
    title: "Talento y equipos por perfilamiento",
    text: "Identificamos las capacidades únicas de cada quien para construir equipos de alto rendimiento.",
  },
  {
    icon: Radio,
    title: "Integración en modelo sistémico",
    text: "Publicidad en «Eco y Cascada»: su mensaje se propaga con estructura por toda la red.",
  },
  {
    icon: MapPinned,
    title: "Destinos turísticos sostenibles",
    text: "Diagnóstico de destino y arquitectura de experiencia, del potencial a la operación.",
  },
  {
    icon: TrendingUp,
    title: "Asesoría de mercadeo digital y posicionamiento",
    text: "A través de BHG Estudio.",
    link: "https://www.bhgve.com",
    linkLabel: "www.bhgve.com",
  },
  {
    icon: FileCheck2,
    title: "Fichas de factibilidad y alineación ODS",
    text: "Convertimos su idea en un proyecto trazable, listo para inversión o cooperación.",
  },
];

export const Servicios = () => {
  return (
    <section id="servicios" className="max-w-6xl mx-auto px-6 py-24 md:py-32" data-testid="section-servicios">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-center max-w-3xl mx-auto mb-14 md:mb-20"
      >
        <p className="text-xs uppercase tracking-[0.35em] text-[#C6A15B] mb-4">Aliarse con BHG</p>
        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white font-medium mb-5" data-testid="servicios-title">
          Lo que antes tomaba un gran equipo, años, reuniones, hoy sistematizado y verificable.
        </h2>
        <p className="text-base md:text-lg text-white/70 mb-6">
          Estrategia con alma y velocidad real. Para empresas y personas que quieren
          profesionalizarse y volverse competitivas.
        </p>
        <p className="text-sm md:text-base text-white/60 leading-relaxed">
          Más de 25 años leyendo sistemas humanos, hoy potenciados con jóvenes con altas capacidades,
          la experiencia, seriedad y dinámica de la «nueva juventud» +50 y la inteligencia artificial.
          No hay moldes: hay soluciones orgánicas, hechas a la medida y ritmo propio.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {SERVICIOS.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.15, ease: "easeOut" }}
              className="liquid-glass rounded-3xl p-8 bg-white/[0.02]"
              data-testid={`servicio-card-${i + 1}`}
            >
              <div className="w-12 h-12 rounded-full border border-[#C6A15B]/40 flex items-center justify-center mb-6">
                <Icon size={20} className="text-[#C6A15B]" />
              </div>
              <h3 className="font-serif-display text-xl text-white font-medium mb-3">{s.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed">{s.text}</p>
            </motion.div>
          );
        })}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
        className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-14"
      >
        <a
          href="https://calendly.com/glendapalai/30min"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="servicios-cta-calendly"
          className="inline-flex items-center justify-center rounded-full bg-[#C6A15B] px-8 py-3.5 text-sm uppercase tracking-widest text-black font-medium hover:bg-[#d9b876] transition-colors"
        >
          Agende un diagnóstico gratis (30 min)
        </a>
        <a
          href="https://wa.me/584244528345"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="servicios-cta-whatsapp"
          className="liquid-glass inline-flex items-center justify-center gap-2 rounded-full px-8 py-3.5 text-sm uppercase tracking-widest text-white hover:text-[#C6A15B] transition-colors bg-white/5"
        >
          <MessageCircle size={16} /> Contacto WhatsApp
        </a>
      </motion.div>
    </section>
  );
};
